<template>
	<div class="wrapInfo">
		<h3 class="titH3">
      投诉信息
			<span v-if="!downIf" class="floatR" @click="downIf = true">收起 <i class="el-icon-arrow-up"></i></span>
			<span v-if="downIf" class="floatR" @click="downIf = false">展开 <i class="el-icon-arrow-down"></i></span>
			<hr>
		</h3>
		<div :class="downIf?'h0':''" class="infoDivBox">
			<div class="row">
				<span class="titSpan">投诉标题：</span>
				{{infoDatas.complaintTitle}}
			</div>
			<div class="row">
				<span class="titSpan">投诉编号：</span>
				{{infoDatas.complaintNo}}
			</div>
			<div class="row">
				<span class="titSpan">投诉人：</span>
				{{infoDatas.complaintPerson}}
			</div>
			<div class="row">
				<span class="titSpan">投诉人电话：</span>
				{{infoDatas.complaintPhone}}
			</div>
			<div class="row">
				<span class="titSpan">投诉时间：</span>
				{{infoDatas.createTime}}
			</div>
			<div class="row">
				<span class="titSpan">问题类型：</span>
				{{infoDatas.problemType}}
			</div>
			<div class="row">
				<span class="titSpan" style="vertical-align: top;">投诉内容：</span>
				<span style="width: 300px;display: inline-block;">{{infoDatas.complaintContent}}</span>
			</div>
			<div class="row">
				<span class="titSpan" style="vertical-align: top;">图片附件：</span>
				<div style="width: 300px;display: inline-block;" v-if="infoDatas.fileList && infoDatas.fileList.length>0">
					<img style="width: 100px;height: 100px;" v-for="item in infoDatas.fileList" :src="$store.getters.baseUrl+ '/' + item.fileUrl" alt="">
				</div>
				<span v-else>无</span>
			</div>
		</div>
	</div>
</template>

<script>
	import { getSchoolInfoFind } from 'api/com'
	export default {
		props: {
			recordId: {
				function () {
					return ''
				}
			}
		},
		data() {
			return {
				downIf: false,
				infoDatas: {}
			}
		},
		mounted() {
			getSchoolInfoFind(this.recordId).then(r => {
				if(r.code == 200){
					this.infoDatas = r.data;
				}
			})
		}
	}
</script>

<style scoped lang="scss">
	.wrapInfo {
		background: #fff;
		overflow: hidden;
		border-radius:4px;
		.titH3{
			font-size: 16px;
			font-weight: 100;
			height: 25px;
			margin: 16px 0;
			padding: 0 30px 0 24px;
			border-left: 6px solid #70CE97;
			span{
				font-size: 14px;
			}
			hr{
				border-width: 0.5px;
				margin-top: 20px;
			}
		}
		.infoDivBox{
			width: 450px;
			margin: 0 auto 20px;
			padding: 10px 0;
			.row{
				font-size: 14px;
				color: #666666;
				margin-top: 20px;
				.titSpan{
					display: inline-block;
					width: 100px;
					text-align: right;
				}
			}
		}
		.h0{
			height: 0;
			margin-bottom: 0;
			padding: 0;
		}
  }
</style>